import {
  ActivatedRoute,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterModule,
} from '@angular/router';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Injector,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import {
  GLOBAL,
  HeaderOptionsConfig,
  NAVIGATION_HEADER,
  headerConstants,
} from './header.config';
import {
  IAccountDetails,
  INotification,
  IUnit,
  IUnitRequest,
} from '../../../models/interfaces/IUser';
import {
  LOCAL_STORAGE_KEYS,
  SESSION_STORAGE_KEYS,
} from '../../../constants/storage.constant';
import {
  DatePipe,
  NgClass,
  NgFor,
  NgIf,
  NgTemplateOutlet,
} from '@angular/common';
import {
  Observable,
  Subject,
  Subscription,
  debounceTime,
  delay,
  distinctUntilChanged,
  filter,
  fromEvent,
  map,
  takeUntil,
} from 'rxjs';

import { AnalyticsService } from '../../../services/analytics-wrapper/analytics.service';
import { BreakpointState } from '@angular/cdk/layout';
import { ButtonComponent } from '../../atoms/button/button.component';
import { CommonUtility } from '../../../utils/commonUtils';
import { LocalStorageUtility } from '../../../../common/utils/localStorageUtils';
import { LocaleService } from '../../../../common/services/locale-wrapper/locale.service';
import { LoginService } from '../../../services/login-service/login.service';
import { MatMenuModule } from '@angular/material/menu';
import { ROUTER_CONSTANTS } from '../../../constants/router.constants';
import { RenderLabelPipe } from '../../../pipes/render-label/render-label.pipe';
import { SearchBarComponent } from '../../molecules/search-bar/search-bar.component';
import { SelectComponent } from '../../atoms/select/select.component';
import { SessionService } from '../../../services/session-service/session.service';
import { ViewportService } from '../../../services/viewport/viewport.service';
import { isB2CEnabled } from '../../../global-config/config';
import { CMSContentStoreService } from '../../../../common/services/cms-content-store/cms-content-store.service';
import { ToastComponent } from '../../molecules/toast/toast.component';
import { USER_TYPES } from '../../../constants/global.constant';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { TrapFocusDirective } from '../../../directives/trap-focus/trap-focus.directive';
import { IApiResponse } from '../../../models/interfaces/IApiResponse';
import { NotificationService } from '../../../services/notification/notification.service';
import { InclusionService } from '../../../../common/services/inclusion-service/inclusion.service';
import {
  IExperiencePayload,
  IExperienceResponse,
  INavMenuItem,
} from '../../../../common/models/interfaces/IInclusion';
import { SessionStorageUtility } from '../../../../common/utils/sessionStorageUtils';
import { HeaderUtil } from '../../../../common/utils/header.util';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { SymphonyDrilldownFacade } from '../../../../common/facades/symphony-drilldown/symphony-drilldown.facade';
import { HamburgerMenuComponent } from '../hamburger-menu/hamburger-menu.component';
import { ToastType } from '../../../../common/enums/toastType.enum';
import { Auth0TokenService } from '../../../../common/services/auth0-service/auth0-service';
import { RequestAccessDataService } from '../../../../modules/request-access/services/request-access-data.service';
import { DecodeValuePipe } from '../../../pipes/sanitizer/decode-value';
import { NavigationHistoryService } from '../../../services/navigation-history/navigation-history.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SelectComponent,
    ReactiveFormsModule,
    RenderLabelPipe,
    NgIf,
    NgFor,
    NgClass,
    RouterModule,
    ButtonComponent,
    MatMenuModule,
    SearchBarComponent,
    ToastComponent,
    TrapFocusDirective,
    NgTemplateOutlet,
    DatePipe,
    NavMenuComponent,
    HamburgerMenuComponent,
    DecodeValuePipe,
  ],
})
export class HeaderComponent implements OnDestroy, OnInit, AfterViewInit {
  url$: Observable<string> = new Observable<string>();
  headerConstants = headerConstants;
  headerConfig: any;
  hasAccess = false;
  isMobile = false;
  gffCRM = true;
  caseManagement = true;
  isDashboardPage = false;
  isSymphonyAccount = CommonUtility.isSymphonyAccount();
  dashboardRoute = `/${ROUTER_CONSTANTS.dashboard}`;
  gffCRMRoute = `/${ROUTER_CONSTANTS.gffCRM}`;
  returnToUrl = '';
  userFirstNameInitial = '';
  companyDetails: IAccountDetails[] = [];
  unitsList: IUnit[] = [];
  unitsOptionsList: any[] = [];
  localeList: any[] = [];
  selectedUnitName = '';
  selectedUnitId = '';
  selectedLocaleName = '';
  dashboardList: any[] = [
    {
      value: 'Case Management',
      viewValue: 'Case Management',
    },
    {
      value: 'GFF CRM',
      viewValue: 'GFF CRM',
    },
  ];
  selectedDashboard = '';
  selectedDashboardName = '';
  selectedLocaleId = '';
  menuItems: any[] = [];
  ngUnsubscribe = new Subject<void>();
  resizeSub: Subscription;
  subHeaderformGrp = this.fb.group({
    locale: [''],
    account: [''],
    dashboard: [''],
  });
  isUpser = false;
  isB2CEnabled = isB2CEnabled;
  deploymentBanner = '';
  isToastVisible = false;
  isAdmin: boolean | undefined = false;
  notificationOverlayRef: OverlayRef;
  @ViewChild('templatePortalContent')
  templatePortalContent: TemplateRef<HTMLElement>;
  notificationTemlatePortal: TemplatePortal<any>;
  previousFocusElement: Element | null;
  userNotifications: INotification[];
  userNotificationsOfToday: INotification[];
  olderUserNotifications: INotification[];
  isNotificationsLoading: boolean = false;
  userNotificationsCount: number;
  isNavigatingFromSymphony: boolean = CommonUtility.isNavigatingFromSymphony();
  accountNumber: number | string | null;
  accountName: string | null = null;
  isMenuItemsLoaded: boolean = false;
  symphonyMenuItems: INavMenuItem[] = [];
  isDesktop: boolean = true;
  symphonyDrilldownFacade: SymphonyDrilldownFacade;
  showHamburger: boolean = false;
  toastVariant: ToastType = ToastType.warning;
  isMessageToastVisible: boolean = false;
  toastMessage: string = '';
  isLoginV2Flag: boolean = false;
  isRequestAccessPage: boolean = false;
  private readonly navigationHistory = inject(NavigationHistoryService);

  constructor(
    private readonly analyticsService: AnalyticsService,
    public readonly router: Router,
    private readonly loginService: LoginService,
    private readonly route: ActivatedRoute,
    private readonly viewportService: ViewportService,
    private fb: FormBuilder,
    private readonly sessionService: SessionService,
    readonly contentPipe: RenderLabelPipe,
    private readonly cdr: ChangeDetectorRef,
    private readonly localeService: LocaleService,
    private readonly _cmsContentStoreService: CMSContentStoreService,
    private readonly announcer: LiveAnnouncer,
    private readonly overlay: Overlay,
    private readonly _renderer: Renderer2,
    private readonly zone: NgZone,
    public readonly elementRef: ElementRef,
    private readonly vcr: ViewContainerRef,
    private singlarService: NotificationService,
    private readonly _inclusionService: InclusionService,
    private readonly auth0TokenService: Auth0TokenService,
    private readonly injector: Injector,
    private readonly requestAccessDataService: RequestAccessDataService,
  ) {
    this.hasAccess = this.loginService.hasAccess;
    this.isAdmin = this.loginService.userProfile?.userDetails?.isAdmin;
    this.notificationOverlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'notifications-panel-backdrop',
    });
    this.symphonyDrilldownFacade = new SymphonyDrilldownFacade(this.injector);
    this.symphonyDrilldownFacade.ngUnsubscribe$ = this.ngUnsubscribe;
    this.subscribeToUnitApiErrorCase();
  }

  /**
   * lifecycle method
   */
  ngAfterViewInit(): void {
    this.setHeaderContainerHeight();
    if (this.templatePortalContent) {
      this.notificationTemlatePortal = new TemplatePortal(
        this.templatePortalContent,
        this.vcr,
      );
    }
  }

  /**
   * Subscribe to Unit API error for Symphony/Symphony Plus
   */
  subscribeToUnitApiErrorCase(): void {
    this.symphonyDrilldownFacade.unitApiErrorSubject$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isError: boolean) => {
        if (isError) {
          this.setErrorToast();
        }
      });
  }

  /**
   * sets Header Container Height css
   */
  setHeaderContainerHeight(): void {
    const headerElement: HTMLElement | null = document.querySelector(
      '.header-wrapper-container',
    );
    const height = headerElement?.offsetHeight ?? 0;

    CommonUtility.updateCSSVariable('--height-header', height + 'px');
  }

  /**
   * lifecycle method
   */
  ngOnInit(): void {
    this.isLoginV2Flag = this.auth0TokenService.appConfig().v2Login;
    this.isRequestAccessPage = this.router.url.includes(
      ROUTER_CONSTANTS.requestAccess,
    );
    if (this.isRequestAccessPage) {
      const requestUser = this.requestAccessDataService.getUserData();
      this.userFirstNameInitial =
        requestUser?.firstName?.trim().toUpperCase().charAt(0) || '';
    }
    // Extract account info from current URL
    this.extractAccountInfoFromRoute();
    this.deploymentBanner = this._cmsContentStoreService.getValue(
      'ct_deployment_banner_message',
    );
    this.isToastVisible = !!this.deploymentBanner;
    if (this.hasAccess) {
      this.initializeLoggedInState();
    }
    this.localeService.localeList
      .pipe(
        takeUntil(this.ngUnsubscribe),
        filter((val) => val?.length > 0),
      )
      .subscribe((list) => {
        this.localeList = list;

        const pathParts =
          CommonUtility.getWindowLocationProperty('pathname').split('/');
        let urlLocale = this.localeService.getLocale(); // default to session

        if (
          pathParts.length >= 3 &&
          pathParts[1]?.length === 2 &&
          pathParts[2]?.length === 2
        ) {
          const urlLanguage = pathParts[2].toLowerCase();
          const urlRegion = pathParts[1].toLowerCase();
          const constructedLocale = `${urlLanguage}_${urlRegion.toUpperCase()}`;
          const localeExists = list.some(
            (locale) =>
              locale.value.toLowerCase() === constructedLocale.toLowerCase(),
          );

          if (localeExists) {
            urlLocale = constructedLocale;
          }
        }

        this.selectedLocaleId = urlLocale;

        this.selectedLocaleName = this.localeList.find(
          (locale) => locale.value === this.selectedLocaleId,
        ).viewValue;

        this.subHeaderformGrp.controls.locale.setValue(this.selectedLocaleId, {
          emitEvent: false,
        });
        this.cdr.detectChanges();
        this.subHeaderformGrp.controls.locale.valueChanges
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((value) => {
            if (value) {
              this.analyticsService.createLinkClickTagObject(
                this.dashboardRoute,
                'Global Header | Locale Selection Drop Down',
                'Locale Selection | Global Header',
                'Internal',
              );
              this.selectedLocaleId = value;
              const selectedLocale = this.localeList.find(
                (locale) => locale.value === value,
              );
              this.selectedLocaleName = selectedLocale.viewValue;
              this.localeService.setLocale(selectedLocale.value);
              this.localeService.navigateWithSelectedLocale();
            }
          });
      });

    this.viewportService.mobileObserver
      .pipe(
        takeUntil(this.ngUnsubscribe),
        debounceTime(200),
        distinctUntilChanged(),
      )
      .subscribe((result: BreakpointState) => {
        this.isMobile = result.matches;
        this.cdr.detectChanges();
      });
    this.viewportService.desktopObserver
      .pipe(
        takeUntil(this.ngUnsubscribe),
        debounceTime(200),
        distinctUntilChanged(),
      )
      .subscribe((result: BreakpointState) => {
        this.isDesktop = result.matches;
        this.cdr.detectChanges();
      });
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe((event) => {
        this.isDashboardPage = event.urlAfterRedirects
          .split('?')[0]
          .includes(ROUTER_CONSTANTS.dashboard);
        this.isRequestAccessPage = event.urlAfterRedirects.includes(
          ROUTER_CONSTANTS.requestAccess,
        );
        const hadAccess = this.hasAccess;
        this.hasAccess = this.loginService.hasAccess;
        this.isAdmin = this.loginService.userProfile?.userDetails?.isAdmin;
        // When navigating from request-access to dashboard, hasAccess flips
        // from false to true for the first time. The if (this.hasAccess) block
        // in ngOnInit was skipped, so we initialise the logged-in state here.
        if (!hadAccess && this.hasAccess) {
          this.initializeLoggedInState();
        }
        this.setHeaderContainerHeight();
        this.setHeaderConfig(event.urlAfterRedirects);
        this.getUserNoticationsCountOnAccess();
        this.cdr.detectChanges();
      });
    this.populateAccountMenuItems();
    this.onWindowResize();
    this.updateSelectedBanner();
    this.loginService.isLoggedInSub
      ?.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((val) => {
        if (val) {
          this.singlarService.startConnection(
            this.notificationListenerHandler.bind(this),
          );
        } else {
          this.singlarService.stopConnection();
        }
      });
  }

  getUserNoticationsCountOnAccess() {
    if (this.hasAccess) {
      this.getUserNotificationsCount();
    }
  }

  /**
   * Fetch Symphony Header Menu Items for Symphony and Symphony plus accounts only
   */
  fetchSymphonyMenuItems(): void {
    if (this.hasAccess && this.isSymphonyAccount) {
      this.isMenuItemsLoaded = false;
      this.symphonyMenuItems = [];
      const symphonyNavHeaderPayload: IExperiencePayload = {
        unitId: this.isNavigatingFromSymphony
          ? SessionStorageUtility.get(SESSION_STORAGE_KEYS.scsUnitId)
          : null,
        salesforceId: this.isNavigatingFromSymphony
          ? null
          : this.companyDetails?.[0]?.number,
        category: GLOBAL,
        pages: NAVIGATION_HEADER,
      };
      this._inclusionService
        .getSymphonyExperience(symphonyNavHeaderPayload)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (response: IExperienceResponse) => {
            if (
              response?.success &&
              !response?.errorDetails?.length &&
              response?.inclusions?.length
            ) {
              const headerComponents =
                response.inclusions?.find(
                  (inclusion) => inclusion.id === NAVIGATION_HEADER,
                )?.components ?? [];

              this.symphonyMenuItems =
                HeaderUtil.formatMenuItemsInclusions(headerComponents);
            } else if (!response?.success || response?.errorDetails?.length) {
              this.setErrorToast();
            }
            this.isMenuItemsLoaded = true;
            this.cdr.detectChanges();
          },
          error: () => {
            this.setErrorToast();
            this.isMenuItemsLoaded = true;
            this.cdr.detectChanges();
          },
        });
    }
  }

  /**
   * Displays error toast message.
   */
  setErrorToast(): void {
    this.toastMessage = 'lbl_error_toast_msg';
    this.toastVariant = ToastType.error;
    this.isMessageToastVisible = true;
    this.cdr.detectChanges();
  }

  /**
   * on Toast Dismiss
   */
  handleDismissToast(): void {
    this.isMessageToastVisible = false;
    this.cdr.detectChanges();
  }

  notificationListenerHandler() {
    this.getUserNotificationsCount();
    if (this.singlarService.isNotificationPanelOpen)
      this.getUserNotifications();
  }
  /**
   * method to update container style on window resize
   */
  onWindowResize(): void {
    this.resizeSub = fromEvent(window, 'resize')
      .pipe(takeUntil(this.ngUnsubscribe), debounceTime(200), delay(2))
      .subscribe(() => {
        this.setHeaderContainerHeight();
      });
  }

  /**
   * prepare Account Selector Options
   */
  prepareAccountSelectorOptions() {
    this.unitsOptionsList = this.unitsList.map((unit: IUnit) => ({
      value: unit.id,
      viewValue: unit.name,
    }));
    if (!this.isUpser) {
      this.unitsOptionsList.sort((firstUnit, secondUnit) =>
        (firstUnit.viewValue || '').localeCompare(secondUnit.viewValue),
      );
    }
  }

  /**
   * set routerLink based on account
   * redirect to symphony dashboard or CM dashboard
   *
   */
  redirectToDashboard() {
    this.trackUPSLogoClickAnalytics();
    if (this.isSymphonyAccount) {
      const symphonyBaseUrl = this.symphonyDrilldownFacade.getSymphonyBaseUrl();
      const selectedLocale = CommonUtility.buildUrlLocale(
        LocalStorageUtility.get(LOCAL_STORAGE_KEYS.selectedLocale),
      );
      const symphonyDashboardUrl = [
        symphonyBaseUrl,
        selectedLocale,
        ROUTER_CONSTANTS.symphony,
        ROUTER_CONSTANTS.dashboard,
      ].join('/');

      this.symphonyDrilldownFacade.navigateToSymphonyPageUrl(
        symphonyDashboardUrl,
        true,
      );
    } else {
      this.router.navigateByUrl(this.dashboardRoute);
    }
  }
  /**
   * track fires on UPSLogoClick
   */
  trackUPSLogoClickAnalytics(): void {
    this.analyticsService.createLinkClickTagObject(
      this.dashboardRoute,
      'UPS Logo',
      'UPS Logo | Global Header',
      'Internal',
    );
  }

  /**
   * redirectToLassoLogin
   */
  redirectToLassoLogin(): void {
    if (this.loginService.isLoggedIn && !this.hasAccess) {
      this.loginService.logout();
    } else {
      this.loginService.redirectToLassoLogin(
        this.route.snapshot.queryParamMap?.get('returnto'),
      );
    }
  }

  /**
   * redirectToB2CLogin
   */
  redirectToB2CLogin(): void {
    if (this.loginService.isLoggedIn && !this.hasAccess) {
      this.loginService.logout();
    } else {
      this.loginService.redirectToB2CLogin(
        this.route.snapshot.queryParamMap?.get('returnto'),
      );
    }
  }

  terinaryReturn(val1: any, val2: any, valCompare: any, valCompare2: any): any {
    if (valCompare === valCompare2) {
      return val1;
    } else {
      return val2;
    }
  }

  /**
   * sets account selector label selector labels
   */
  getAccountSelectorLabel() {
    let array = [] as IUnit[];
    if (this.unitsList) {
      array = this.unitsList;
    }
    const unitParentDetail = array.filter((unit) =>
      this.companyDetails.some((selectedUnit) => +selectedUnit.id === +unit.id),
    );
    if (unitParentDetail?.length && this.companyDetails.length > 1) {
      // selector name when company have parent company
      this.selectedUnitName = `${unitParentDetail[0].name} (${this.companyDetails.length})`;
    } else {
      if (this.isUpser && this.companyDetails[0]?.name === 'UPS') {
        const myUnitIndex = this.unitsList.findIndex(
          (unit) => unit.id.split('_')[1] === 'My',
        );
        const allUnitIndex = this.unitsList.findIndex(
          (unit) => unit.id.split('_')[1] === 'All',
        );
        this.selectedUnitName = this.terinaryReturn(
          this.unitsList[myUnitIndex].name,
          this.unitsList[allUnitIndex].name,
          this.loginService.userProfile?.userDetails.variance,
          'Contact',
        );
        this.selectedUnitId = this.terinaryReturn(
          this.unitsList[myUnitIndex].id,
          this.unitsList[allUnitIndex].id,
          this.loginService.userProfile?.userDetails.variance,
          'Contact',
        );
      } else {
        this.selectedUnitName = this.companyDetails[0]?.name;
        this.selectedUnitId = this.companyDetails[0]?.id;
      }
    }
    this.subHeaderformGrp.controls.account.setValue(this.selectedUnitId, {
      emitEvent: false,
    });
  }

  signOut(): void {
    this.loginService.logout();
  }

  private initializeLoggedInState(): void {
    this.url$ = this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url),
    );
    this.isUpser =
      this.loginService.userProfile?.userDetails?.userType?.toLowerCase() ===
      USER_TYPES.upser;
    this.userFirstNameInitial =
      this.loginService.userProfile?.userDetails.firstName
        ?.trim()
        .toUpperCase()
        .charAt(0) || '';
    this.companyDetails = this.loginService.userProfile?.accountDetails ?? [];
    this.loginService.unitsList
      .pipe(
        takeUntil(this.ngUnsubscribe),
        filter((val) => val?.length > 0),
      )
      .subscribe((list) => {
        if (this.isUpser) {
          const upsIndex = list.findIndex((unit) => unit.name === 'UPS');
          this.unitsList = [
            ...(upsIndex !== -1
              ? [
                  {
                    id: list[upsIndex].id + '_My',
                    name: this.contentPipe.transform('header_upser_my_cases'),
                  },
                  {
                    id: list[upsIndex].id + '_All',
                    name:
                      this.contentPipe.transform('header_upser_all_cases') +
                      ' (' +
                      list[upsIndex].name +
                      ')',
                  },
                ]
              : []),
            ...list
              .filter((unit) => unit.name !== 'UPS')
              .sort((unit1, unit2) =>
                unit1.name?.toUpperCase() < unit2.name?.toUpperCase() ? -1 : 1,
              ),
          ];
        } else {
          this.unitsList = list;
        }
        this.prepareAccountSelectorOptions();
        this.getAccountSelectorLabel();
        this.cdr.detectChanges();
        this.subHeaderformGrp.controls.account.valueChanges
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((value) => {
            if (value) {
              this.analyticsService.createLinkClickTagObject(
                this.dashboardRoute,
                'Global Header | Account Selection Drop Down',
                'Account Selection | Global Header',
                'Internal',
              );
              const unit: IUnitRequest = { account: value.split('_')[0] };
              if (this.isUpser) {
                unit.variance =
                  value.split('_')[1] === 'My' ? 'Contact' : 'Account';
              }
              this.loginService
                .setUserUnits(unit)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe();
            }
          });
      });

    if (this.isSymphonyAccount) {
      this.fetchSymphonyMenuItems();
    }
  }

  populateAccountMenuItems() {
    this.menuItems = [
      {
        name: 'account',
        hide: !this.isSymphonyAccount,
        handler: () => {
          this.symphonyDrilldownFacade.navigateToSymphonyPageUrl(
            '/account',
            false,
            true,
          );
        },
      },
      {
        name: 'admin',
        hide: !this.isAdmin,
        handler: () => {
          this.router.navigate([`${ROUTER_CONSTANTS.admin}`]);
        },
      },
      {
        name: 'signOut',
        handler: () => {
          this.loginService.logout();
        },
      },
    ];
  }

  setHeaderConfig(url: string) {
    const pageUrl: string[] = url.split('?')[0].split('/');
    const queryParams = CommonUtility.getQueryParams();
    pageUrl.splice(0, 1);
    let pageName = '';
    let id = '';
    if (pageUrl.length > 1) {
      pageName = pageUrl.slice(0, pageUrl.length - 1).join('/');
      id = pageUrl[pageUrl.length - 1];
    } else {
      pageName = pageUrl[0];
      id = '';
    }

    if (pageUrl.includes(ROUTER_CONSTANTS?.contacts)) {
      pageName = ROUTER_CONSTANTS?.contacts;
    } else if (pageUrl.includes(ROUTER_CONSTANTS?.viewAccountHierarchy)) {
      pageName = ROUTER_CONSTANTS?.viewAccountHierarchy;
    } else if (pageUrl.includes(ROUTER_CONSTANTS?.productDetail)) {
      pageName = ROUTER_CONSTANTS?.productDetail;
    }
    this.headerConfig = HeaderOptionsConfig(this)[pageName] || {
      showBackBtn: false,
      customText: null,
      analyticsCMS: null,
    };
    this.cdr.detectChanges();
    if (this.headerConfig.customTextCallBack && id) {
      this.headerConfig.customText = this.headerConfig.customTextCallBack(
        id,
        queryParams,
      );
    }
    this.sessionService.set(
      SESSION_STORAGE_KEYS.logoTextLabel,
      this.headerConfig.analyticsCMS,
    );
  }
  onToastMessageBarClose(): void {
    this.isToastVisible = false;
    this.cdr.detectChanges();
    this.setHeaderContainerHeight();
  }
  /**
   * Browser-like back that preserves the latest selected locale; falls back to dashboard.
   */
  handleBackClick(): void {
    this.analyticsService.createLinkClickTagObject(
      this.dashboardRoute,
      'UPS Back Button',
      'UPS Back Button | Global Header',
      'Internal',
    );
    this.navigationHistory.back(this.dashboardRoute);
  }

  updateSelectedBanner() {
    this.router.events
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => {
        this.validateEvent(event);
      });
  }

  validateEvent(event: any) {
    let url: string;
    if (
      event instanceof NavigationStart ||
      event instanceof NavigationEnd ||
      event instanceof NavigationError
    ) {
      url = event.url.includes('?') ? event.url.split('?')[0] : event.url;
      this.selectedDashboard = url.includes('/gffCRM')
        ? 'GFF CRM'
        : 'Case Management';
      this.selectedDashboardName = this.selectedDashboard;
    }
  }

  dashboardNavigation(event?: any) {
    if (event?.viewValue && this.selectedDashboardName !== event.viewValue) {
      this.selectedDashboardName = event.viewValue;
    }
    if (this.selectedDashboardName === 'GFF CRM') {
      this.loadGFFCRM();
    } else if (this.selectedDashboardName === 'Case Management') {
      this.redirectToDashboard();
    }
  }

  loadGFFCRM(): void {
    if (this.gffCRM) {
      this.router.navigateByUrl(this.gffCRMRoute);
    }
  }
  /**
   * detach overlay
   */
  detachNotificationOverlay(): void {
    if (this.notificationOverlayRef.hasAttached()) {
      this.notificationOverlayRef.detach();
      this.cdr.detectChanges();
    }
  }
  /**
   * attach overlay in mobile and tablet view
   */
  showNotificationOverlay(): void {
    if (this.notificationTemlatePortal) {
      this.notificationOverlayRef.attach(this.notificationTemlatePortal);
      this.notificationOverlayRef
        .backdropClick()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(() => {
          this.toggleNotifications(true);
        });
    }
  }

  toggleNotifications(isCloseClicked = false, showNotificationLoader = true) {
    if (isCloseClicked) {
      this.detachNotificationOverlay();
      this.announcer.announce(
        this.contentPipe.transform('filters_open_panel_btn') +
          this.contentPipe.transform('panel_closed_announce'),
      );
      if (this.previousFocusElement) {
        CommonUtility.focusComponent(
          this.zone,
          this._renderer,
          this.previousFocusElement,
        );
      }
      this.singlarService.isNotificationPanelOpen = false;
    } else {
      this.previousFocusElement = document.activeElement;
      this.isNotificationsLoading = showNotificationLoader;
      this.getUserNotifications();
      this.showNotificationOverlay();
      this.singlarService.isNotificationPanelOpen = true;
      CommonUtility.focusComponent(
        this.zone,
        this._renderer,
        '.overlay-notifications-header .close-btn',
      );
      this.announcer.announce(
        this.contentPipe.transform('filters_open_panel_btn') +
          this.contentPipe.transform('panel_opened_announce'),
      );
    }
    this.cdr.detectChanges();
  }
  getUserNotificationsCount() {
    this.loginService
      .getUserNotificationsCount()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res?.success) {
          this.userNotificationsCount = res?.count;
          this.cdr.detectChanges();
        }
      });
  }
  getUserNotifications() {
    this.loginService
      .getUserNotifications()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res?.success) {
          this.userNotifications =
            res?.list.map((el) => {
              return {
                ...el,
                ...this.checkTimestampAndCalculateDifference(el.createdDate),
              };
            }) || [];
          this.userNotificationsOfToday = this.userNotifications.filter(
            (el) => el.isToday,
          );
          this.olderUserNotifications = this.userNotifications.filter(
            (el) => !el.isToday,
          );
        }
        this.isNotificationsLoading = false;
        this.cdr.detectChanges();
      });
  }
  checkTimestampAndCalculateDifference(timestamp: string) {
    // Get the current date and time
    const now: any = new Date();

    // Parse the given timestamp
    const givenTime: any = new Date(timestamp);

    // Check if the given timestamp is from today
    const isToday = givenTime.toDateString() === now.toDateString();

    if (isToday) {
      // Calculate the difference in milliseconds
      const diff = Math.abs(now - givenTime);

      // Convert the difference to hours and minutes
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      return {
        isToday: true,
        difference: `${hours} hours ${minutes} minutes ago`,
      };
    } else {
      return {
        isToday: false,
        difference: null,
      };
    }
  }
  markNotificationAsRead(
    notification: INotification,
    type: 'ALL' | 'SINGLE' | 'BYCASE',
  ) {
    if (notification) {
      this.isNotificationsLoading = true;
      this.loginService
        .markNotificationsAsRead(notification.id, {
          isRead: true,
          isAllRead: type === 'ALL',
          isReadbyCase: type === 'BYCASE',
        })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: IApiResponse) => {
          if (res?.success) {
            this.getUserNotifications();
            this.getUserNotificationsCount();
            if (type === 'BYCASE') {
              this.router.navigate(
                [`${ROUTER_CONSTANTS.detail}/${notification.caseId}`],
                {
                  queryParams: { caseNumber: notification.caseNumber },
                },
              );
              this.cdr.detectChanges();
            }
          }
        });
    }
    this.cdr.detectChanges();
  }
  /**
   * ngOnDestroy lifecycle hook
   */
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.resizeSub?.unsubscribe();
  }

  showOrHideHamburgerMenu(isHide?: boolean): void {
    this.showHamburger = isHide ? false : !this.showHamburger;
  }

  /**
   * redirects to login page using auth0 service
   */
  redirectToAuth0Login(): void {
    const currentUrl: string = CommonUtility.getWindowLocationProperty('href');
    if (currentUrl.includes(ROUTER_CONSTANTS.noAccess)) {
      this.loginService.logout();
    } else {
      this.loginService.redirectToAuth0Login();
    }
  }

  /**
   * redirects to Ups employee login page using
   */
  redirectToUPSerLogin(): void {
    const currentUrl: string = CommonUtility.getWindowLocationProperty('href');
    // we show no access page on multilpe scenarios, for the case when user logged in via B2E,
    // they can get this page if they are unauthorised or if there were msal errors(user can be valid or invalid)
    // for the latter case a valid user will see no access again n again if they were to login, so logging them out
    if (currentUrl.includes(ROUTER_CONSTANTS.noAccess)) {
      this.loginService.logout();
    } else {
      this.loginService.redirectToEntraIdLogin();
    }
  }

  /**
   * Navigate to account details page or scroll to top if already on the page
   */
  navigateToAccountDetails(): void {
    if (!this.accountNumber) {
      return;
    }

    // Build the target account details URL with query params
    const targetPath = `/${ROUTER_CONSTANTS.viewAccount}/${this.accountNumber}`;
    const targetQueryParams =
      'accountName=' +
      encodeURIComponent(this.accountName ?? '') +
      '&accountNumber=' +
      encodeURIComponent(this.accountNumber?.toString() ?? '') +
      '&tab=dt_details';
    const targetUrl = `${targetPath}?${targetQueryParams.toString()}`;

    // Get current URL and encode it properly for comparison
    const currentUrl = decodeURIComponent(this.router.url);
    const encodedTargetUrl = decodeURIComponent(targetUrl);

    // If already on the exact account details page with same query params, just scroll to top
    if (currentUrl === encodedTargetUrl) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    // Navigate to account detail page
    this.router.navigate([targetPath], {
      queryParams: {
        accountName: this.accountName,
        accountNumber: this.accountNumber,
        tab: 'dt_details',
      },
    });
  }

  public extractAccountInfoFromRoute(): void {
    // Parse current URL for account info
    this.parseCurrentUrlForAccountInfo();

    // Set up subscription to listen for URL changes (only once)
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe(() => {
        // Only parse URL, don't call extractAccountInfoFromRoute again
        this.parseCurrentUrlForAccountInfo();
      });
  }

  /**
   * Get current URL for parsing - extracted to make it testable
   * @returns current URL string
   */
  protected getCurrentUrl(): string {
    return window.location.href;
  }

  private parseCurrentUrlForAccountInfo(): void {
    // Use getCurrentUrl() method to get the complete URL since router.url might return "/"
    const currentUrl = this.getCurrentUrl();

    // Reset values first
    this.accountNumber = null;
    this.accountName = null;

    // Extract account number from path like /account/123123910
    const accountMatch = currentUrl.match(/\/account\/(\d+)/);
    if (accountMatch) {
      this.accountNumber = accountMatch[1];
    }

    // Extract account name from query params
    if (currentUrl.includes('accountName=')) {
      const nameMatch = currentUrl.match(/accountName=([^&]*)/);
      if (nameMatch) {
        this.accountName = decodeURIComponent(nameMatch[1]);
      }
    }
  }
}
